import { createApi } from '@reduxjs/toolkit/query/react';
import { UUID } from '@/types';
import ColumnName from '@/util/ColumnName';
import { baseQuery } from '@/api/baseQuery';

export const GET_AVAILABLE_CHARTS = 'getAvailableCharts';

export type TChartType =
  | 'table'
  | 'single_value'
  | 'bar'
  | 'line'
  | 'pie'
  | 'pivot'
  | 'bar_line'
  | 'stacked';

export const QUERY_AVAILABLE_CHARTS = 'QUERY_AVAILABLE_CHARTS';

export type TGetAvailableChartsInput = { datasourceId: UUID; seriesId: UUID };
export type TSelectedMetricsDimensions = {
  metrics: ColumnName[];
  dimensions: ColumnName[];
};

export type TGetAvailableChartsResponse = Partial<
  Record<
    TChartType,
    {
      metricColumns: ColumnName[];
      dimensionColumnsCombinations: ColumnName[][];
      prefill: TSelectedMetricsDimensions;
    }
  >
>;

export const chartConfigurationApi = createApi({
  tagTypes: [QUERY_AVAILABLE_CHARTS],
  reducerPath: 'chartConfigurationApi',
  baseQuery,
  endpoints: (builder) => ({
    [GET_AVAILABLE_CHARTS]: builder.query<
      TGetAvailableChartsResponse,
      TGetAvailableChartsInput
    >({
      query: ({ datasourceId, seriesId }) =>
        `datasources/${datasourceId}/saved-queries/get-available-charts/${seriesId}`,
      providesTags: [QUERY_AVAILABLE_CHARTS],
    }),
  }),
});

export const { useGetAvailableChartsQuery } = chartConfigurationApi;
